
import ApplicationForm from "./ApplicationForm";
import LocationBadge from "./LocationBadge";

const JobCard = ({ data }) => {

  return (
    <>
      <div className="w-full sm:max-w-[350px] max-w-full h-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
        <div className="sm:h-48 h-24 w-full "><img className="rounded-t-lg w-full h-full object-cover" src={data.image} /></div>
        <div className="flex flex-col h-full w-full gap-2 p-4">
          <h5 className="mb-1 text-xl font-medium text-gray-900 dark:text-white just">{data.role}</h5>
          <div className="flex flex-row gap-2">
            {data.locations.map((location) => (
              <LocationBadge key={location}>{location}</LocationBadge>
            ))}
          </div>
          <div className="w-5/6 h-full">
            {data.description}
          </div>
          <ApplicationForm role={data.role} />
        </div>
      </div>
    </>
  );
};

export default JobCard;
